// extracted by mini-css-extract-plugin
export default {"body":"postContent_body__ruCJJ","article":"postContent_article__HbxOK","preview":"postContent_preview__iI4Di","link":"postContent_link__bvHSa"};